import React from "react";
import { StyledLinkItem } from "./style";
import makeSafe from "../../../../lib/makeSafeToUseInDangerousInnerHtml";

const Index = ({
  title,
  icon,
  SvgIcon,
  color,
  backgroundColor,
  expand,
  activeClassName,
  className,
  onClick
}) => {
  return (
    <StyledLinkItem
      title={title}
      color={color}
      expand={expand ? expand.toString() : ""}
      backgroundcolor={backgroundColor}
      activeClassName={activeClassName}
      className={className}
      onClick={onClick}
    >
      <li>
        {icon && <i className={`icon ${icon}`} />}
        {SvgIcon && (
          <span className="svg-icon-wrapper">
            <SvgIcon />
          </span>
        )}
        <span
          className="list-item-text"
          dangerouslySetInnerHTML={{
            __html: makeSafe(title)
          }}
        />
      </li>
    </StyledLinkItem>
  );
};

export default Index;
